/**
 * HoverStatusStrip.tsx
 * A thin status bar rendered between the Skill Matrix table and the legend.
 *
 * Shows the currently-hovered cell's employee, test name, and skill level
 * in a quiet, non-popup style — no tooltip flickering.
 *
 * Fixed height (32px) so the layout never jumps when hover state changes.
 */

import React from 'react';
import { Box, Typography } from '@mui/material';

export interface HoverInfo {
  user: string;
  task: string;
  levelLabel: string;
}

interface HoverStatusStripProps {
  hoverInfo: HoverInfo | null;
}

export const HoverStatusStrip: React.FC<HoverStatusStripProps> = ({ hoverInfo }) => {
  return (
    <Box
      sx={{
        height: 32,
        px: 2,
        display: 'flex',
        alignItems: 'center',
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.default',
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: hoverInfo ? 'text.secondary' : 'text.disabled',
          fontFamily: '"Roboto Mono", "Consolas", monospace',
          fontSize: '0.72rem',
          letterSpacing: '0.01em',
          lineHeight: 1,
          userSelect: 'none',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {hoverInfo
          ? `${hoverInfo.user} · ${hoverInfo.task} · ${hoverInfo.levelLabel}`
          : 'Hover a cell to see details'}
      </Typography>
    </Box>
  );
};
